import { useTranslation } from "react-i18next";
import {
  CalendarDaysIcon,
  ClipboardDocumentListIcon,
  PlusIcon,
  NoSymbolIcon,
} from "@heroicons/react/24/outline";
import { PMDialog } from "../../utils/PMDialog";
import { format } from "date-fns";
import { currentDateFnsLocale } from "../../../i18n/dateLocales";

const ACTIONS = [
  {
    key: "plan",
    labelKey: "project.plan.day_action.new_plan",
    icon: PlusIcon,
    accent: "text-[#2B6CFF]",
  },
  {
    key: "activity",
    labelKey: "project.plan.day_action.activity",
    icon: ClipboardDocumentListIcon,
    accent: "text-violet-600",
  },
  {
    key: "task",
    labelKey: "project.plan.day_action.task",
    icon: CalendarDaysIcon,
    accent: "text-[#0B7A3B]",
  },
  {
    key: "absence",
    labelKey: "project.plan.day_action.absence",
    icon: NoSymbolIcon,
    accent: "text-amber-600",
    adminOnly: true,
  },
];

/**
 * Small picker when clicking + on a day column: plan / activity / task / absence.
 */
export function PlanDayActionDialog({
  open,
  onClose,
  dateKey = null,
  canAddAbsence = false,
  onSelect,
}) {
  const { t } = useTranslation();

  const dateLabel = (() => {
    if (!dateKey) return "";
    try {
      return format(new Date(`${dateKey}T12:00:00`), "EEEE d. MMMM yyyy", {
        locale: currentDateFnsLocale(),
      });
    } catch {
      return dateKey;
    }
  })();

  const visible = ACTIONS.filter((a) => !a.adminOnly || canAddAbsence);

  return (
    <PMDialog
      open={open}
      onClose={onClose}
      title={t("project.plan.day_action.title")}
      size="sm"
    >
      {dateLabel ? (
        <p className="mb-3 text-sm text-[#6B7682]">
          {t("project.plan.day_action.subtitle", { date: dateLabel })}
        </p>
      ) : null}

      <div className="flex flex-col gap-1.5">
        {visible.map(({ key, labelKey, icon: Icon, accent }) => (
          <button
            key={key}
            type="button"
            className="flex w-full items-center gap-3 rounded-[10px] border border-[#E5E9F0] bg-white px-3.5 py-3 text-left text-[14px] font-medium text-[#0B1220] transition hover:border-[#D6DCE5] hover:bg-[#F6F8FB]"
            onClick={() => {
              onSelect?.(key, dateKey);
              onClose?.();
            }}
          >
            <Icon className={`h-5 w-5 shrink-0 ${accent}`} />
            <span>{t(labelKey)}</span>
          </button>
        ))}
      </div>
    </PMDialog>
  );
}
